import { Badge, Button, Typography } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

import { VerticalDivider } from '@hero/atoms';
import { DEVICE } from '@hero/constants';

const PageSteps = styled.div`
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

const HeaderTop = styled.div`
  ${({ hasSteps }) => {
    if (hasSteps)
      return css`
        align-items: center;
        display: grid;
        grid-template-columns: 250px 1fr 250px;

        ${DEVICE.tablet.max} {
          grid-template-columns: 4fr 10fr 4fr;
        }

        ${DEVICE.tablet.mid} {
          grid-template-columns: 1fr 1fr;

          ${PageSteps} {
            grid-column: span 2;
            order: 3;
          }
        }
      `;

    return css`
      align-items: center;
      display: flex;
      justify-content: space-between;
    `;
  }}

  ${DEVICE.mobile.max} {
    flex-direction: column;
    gap: 8px;
    padding-left: 80px;
  }
`;

const PageTitle = styled.div`
  align-items: center;
  display: flex;

  ${DEVICE.mobile.max} {
    align-items: center;
    gap: 8px;
    justify-content: space-between;
    width: 100%;

    ${VerticalDivider} {
      display: none;
    }

    ${Typography.S.Typography} {
      font-size: 16px;
    }
  }
`;

const Header = styled.div`
  background-color: var(--color-bg-body);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-height: ${({ hasSubtitle }) => (hasSubtitle ? '210px' : '152px')};
  padding: var(--size-page-padding-md) var(--size-page-padding-xxl) var(--size-page-padding-md)
    var(--size-page-padding-xxl);

  ${({ showBorder }) => {
    return (
      showBorder &&
      css`
        border-bottom: 1px solid var(--color-border-default);
      `
    );
  }}

  ${DEVICE.mobile.max} {
    padding: var(--size-page-padding-sm);
  }
`;

const ExtraTitle = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

const EndButton = styled(Button)`
  justify-self: flex-end;
  text-transform: none;
`;

const CallLink = styled(Button)`
  justify-self: flex-end;

  ${DEVICE.desktop.min} {
    font-size: 0px;
    padding-left: var(--size-padding-24);
  }
  a {
    color: var(--color-components-button-secondary-link-fg);
  }
`;

const EndArea = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-self: flex-end;
`;

const Step = styled(Button)`
  padding: 0;
  width: fit-content;

  &:disabled {
    color: var(--color-fg-weakest3);
  }
`;

const StepWrapper = styled.div`
  align-items: center;
  display: flex;
`;

const IconWrapper = styled.div`
  background: var(--color-accent-primary-stronger);
  border-radius: var(--radius-full);
`;

const StepNumber = styled.div`
  align-items: center;
  background-color: var(--color-bg-stronger);
  border-radius: var(--size-border-radius-circle);
  display: flex;
  height: 40px;
  justify-content: center;
  margin-right: 16px;
  width: 40px;
`;

const InfoBadge = styled(Badge)`
  background-color: var(--color-bg-weaker);
  margin: auto 16px;
`;

export {
  CallLink,
  EndArea,
  EndButton,
  ExtraTitle,
  Header,
  HeaderTop,
  IconWrapper,
  InfoBadge,
  PageSteps,
  PageTitle,
  Step,
  StepNumber,
  StepWrapper
};
